"use client";

import { useEffect } from "react";

const DocsLoadedNotifier = () => {
  useEffect(() => {
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
      window.parent.postMessage("docsLoaded", "*");
    }
  }, []);

  return null;
};

export default DocsLoadedNotifier;
